export const LOADING_BAR_LABELS = {
  CONNECTING: 'Connecting to bank',
  WAIT: 'Please wait...',
};
